import React from "react";
import SideNavbar from "./SideNav";

const THUserContent = ({ trackId }) => {
  return (
    <div>
      <SideNavbar trackId={trackId} />
    </div>
  );
};

export default THUserContent;
